import {LOAD_SHOWS, LOAD_SHOW_DETAILS} from '../actions/show';

const initialState = {
    loading: true,
    shows: undefined,
    show: undefined,
    expireTime: 0,
};

export default function showReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_SHOWS:
            if (action.payload.shows && !action.payload.loading) {
                let {recommendation, shows} = action.payload;

                var scoredShows = shows.reduce((current, show) => {
                    let savedShow = recommendation.shows[show.id];
                    var score = 0;
                    if (savedShow) {
                        // 1 point for each time accessed,
                        // 100 points for being favorite
                        score =
                            savedShow.timesAccessed +
                            (savedShow.isFavorite ? 100 : 0);
                    }
                    return {...current, [show.id]: {score: score, show}};
                }, {});

                //add 1 point for each video started, 3 points for finished
                Object.keys(recommendation.videos).forEach(key => {
                    let savedVideo = recommendation.videos[key];
                    if (savedVideo.showId) {
                        let scoredShow = scoredShows[savedVideo.showId];
                        if (scoredShow) {
                            scoredShow.score +=
                                savedVideo.timesStarted +
                                savedVideo.timesEnded * 3;
                        }
                    }
                });

                //sort and map back into shows
                let sorted = Object.keys(scoredShows)
                    .map(key => scoredShows[key])
                    .sort(scoreSort)
                    .map(e => e.show);
                let now = new Date().getTime();

                return {...state, shows: sorted, expireTime: now + 60 * 1000};
            } else {
                return {...state, ...action.payload};
            }

        case LOAD_SHOW_DETAILS:
            return {
                ...state,
                show: {
                    ...state.show,
                    [action.payload.show.id]: action.payload.show,
                },
            };

        default:
            return state;
    }
}

const scoreSort = (e1, e2) => {
    if (e1.score < e2.score) {
        return 1;
    } else if (e1.score > e2.score) {
        return -1;
    } else {
        if (e1.show.title > e2.show.title) {
            return 1;
        } else if (e1.show.title < e2.show.title) {
            return -1;
        }
        return 0;
    }
};
